import {Component} from 'react';

export default class UnionSearch extends Component {
  searchByData = (data, noTable) => {
    const {pageStatus, getTableList, actions} = this.props;
    // 设置搜索条件
    actions.setSearchData({...data});
    // 设置分页
    actions.setPageStatus({pageNum: 1});
    if (!noTable) {
      // 获取table列表数据
      getTableList({
        ...data,
        ...pageStatus,
        pageNum: 1,
      });
    }
  };

  onOk = (params = {}, noTable) => {
    const {searchData} = this.props;
    const extendParams = {
      ...searchData,
      ...params,
    };
    this.searchByData(extendParams, noTable);
  };
}
